'use es6';

import { Map as ImmutableMap } from 'immutable';
import TwoFactorAuthActionTypes from '../actions/TwoFactorAuthActionTypes';
import TwoFactorAuthAppStates from '../constants/TwoFactorAuthAppStates';
import TwoFactorAuthLevels from '../constants/TwoFactorAuthLevels';
const initialState = new ImmutableMap({
  appState: TwoFactorAuthAppStates.DEFAULT,
  credentials: {},
  totp: '',
  twoFactorLevel: TwoFactorAuthLevels.PRIMARY,
  primary: null,
  secondary: null,
  token: null,
  rememberThisDevice: false,
  backupCodesEnabled: true,
  isVerifying: false,
  isRequestingCode: false,
  isInvalidCodeAlertVisible: false,
  isTokenExpiredAlertVisible: false,
  isNewCodeSentAlertVisible: false,
  isInvalidTokenAlertVisible: false,
  isSmsRateLimitAlertVisible: false,
  isGenericTwoFactorErrorAlertVisible: false,
  isUserDeactivatedAlertVisible: false,
  hubspotAuthenticatorResponse: null,
  isRememberThisDeviceModalOpen: false,
  isLoginWithHSPrompt: false
});
export default function twoFactorAuth(state = initialState, action) {
  switch (action.type) {
    case TwoFactorAuthActionTypes.START_VERIFYING:
      return state.merge({
        isVerifying: true,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });

    case TwoFactorAuthActionTypes.FINISH_VERIFYING:
      return state.set('isVerifying', false);

    case TwoFactorAuthActionTypes.START_REQUESTING_CODE:
      return state.merge({
        isRequestingCode: true,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });

    case TwoFactorAuthActionTypes.FINISH_REQUESTING_CODE:
      return state.set('isRequestingCode', false);

    case TwoFactorAuthActionTypes.UPDATE_TOTP:
      return state.merge({
        totp: action.payload.totp,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });

    case TwoFactorAuthActionTypes.SET_TWO_FACTOR_METHOD:
      return state.merge({
        token: action.payload.token,
        twoFactorLevel: TwoFactorAuthLevels.PRIMARY,
        primary: action.payload.primary,
        secondary: action.payload.secondary,
        backupCodesEnabled: action.payload.backupCodesEnabled,
        totp: '',
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false,
        isNewCodeSentAlertVisible: false,
        hubspotAuthenticatorResponse: null
      });

    case TwoFactorAuthActionTypes.SWITCH_TWO_FACTOR_METHOD:
      return state.merge({
        twoFactorLevel: state.get('twoFactorLevel') === TwoFactorAuthLevels.PRIMARY ? TwoFactorAuthLevels.SECONDARY : TwoFactorAuthLevels.PRIMARY,
        totp: '',
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false,
        isNewCodeSentAlertVisible: false,
        hubspotAuthenticatorResponse: null
      });

    case TwoFactorAuthActionTypes.SET_CREDENTIALS:
      return state.set('credentials', action.payload.credentials);

    case TwoFactorAuthActionTypes.SHOW_TOKEN_EXPIRED:
      return state.set('isTokenExpiredAlertVisible', true);

    case TwoFactorAuthActionTypes.HIDE_TOKEN_EXPIRED:
      return state.set('isTokenExpiredAlertVisible', false);

    case TwoFactorAuthActionTypes.SHOW_NEW_CODE_SENT:
      return state.merge({
        isNewCodeSentAlertVisible: true,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });

    case TwoFactorAuthActionTypes.HIDE_NEW_CODE_SENT:
      return state.set('isNewCodeSentAlertVisible', false);

    case TwoFactorAuthActionTypes.SHOW_INVALID_CODE:
      return state.set('isInvalidCodeAlertVisible', true);

    case TwoFactorAuthActionTypes.HIDE_INVALID_CODE:
      return state.set('isInvalidCodeAlertVisible', false);

    case TwoFactorAuthActionTypes.SHOW_INVALID_TOKEN:
      return state.set('isInvalidTokenAlertVisible', true);

    case TwoFactorAuthActionTypes.HIDE_INVALID_TOKEN:
      return state.set('isInvalidTokenAlertVisible', false);

    case TwoFactorAuthActionTypes.SHOW_SMS_RATE_LIMIT:
      return state.set('isSmsRateLimitAlertVisible', true);

    case TwoFactorAuthActionTypes.HIDE_SMS_RATE_LIMIT:
      return state.set('isSmsRateLimitAlertVisible', false);

    case TwoFactorAuthActionTypes.SHOW_GENERIC_TWO_FACTOR_ERROR:
      return state.set('isGenericTwoFactorErrorAlertVisible', true);

    case TwoFactorAuthActionTypes.HIDE_GENERIC_TWO_FACTOR_ERROR:
      return state.set('isGenericTwoFactorErrorAlertVisible', false);

    case TwoFactorAuthActionTypes.SHOW_USER_DEACTIVATED:
      return state.set('isUserDeactivatedAlertVisible', true);

    case TwoFactorAuthActionTypes.HIDE_USER_DEACTIVATED:
      return state.set('isUserDeactivatedAlertVisible', false);

    case TwoFactorAuthActionTypes.TOGGLE_REMEMBER_DEVICE:
      return state.set('rememberThisDevice', !state.get('rememberThisDevice'));

    case TwoFactorAuthActionTypes.TOGGLE_REMEMBER_DEVICE_MODAL:
      return state.set('isRememberThisDeviceModalOpen', !state.get('isRememberThisDeviceModalOpen'));

    case TwoFactorAuthActionTypes.SWITCH_APP_STATE:
      {
        const appState = state.get('appState') === TwoFactorAuthAppStates.DEFAULT ? TwoFactorAuthAppStates.BACKUP : TwoFactorAuthAppStates.DEFAULT;
        const twoFactorLevel = action.payload.level || state.get('twoFactorLevel');
        return state.merge({
          appState,
          twoFactorLevel,
          totp: '',
          isInvalidCodeAlertVisible: false,
          isGenericTwoFactorErrorAlertVisible: false,
          isNewCodeSentAlertVisible: false,
          hubspotAuthenticatorResponse: null
        });
      }

    case TwoFactorAuthActionTypes.UPDATE_HUBSPOT_APP_STATUS:
      return state.set('hubspotAuthenticatorResponse', action.payload);

    case TwoFactorAuthActionTypes.CLICKED_BACK_BUTTON:
      return initialState;

    case TwoFactorAuthActionTypes.LOGIN_WITH_HS_PROMPT:
      return state.merge({
        isLoginWithHSPrompt: true
      });

    default:
      return state;
  }
}